export default __webpack_public_path__ + "static/media/cave.8ba3056b.jpg";